var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 19,
    height: 19,
    rx: 5.5,
    fill: "#E7EEFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 19,
    height: 19,
    rx: 5.5,
    stroke: "#BDCFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.63477V7.70004C11 7.98006 11 8.12007 11.0545 8.22703C11.1024 8.32111 11.1789 8.3976 11.273 8.44554C11.38 8.50004 11.52 8.50004 11.8 8.50004H13.8653M8.5 12L10 13.5M10 13.5L11.5 12M10 13.5L10 10.5M11 5.5H8.4C7.55992 5.5 7.13988 5.5 6.81901 5.66349C6.53677 5.8073 6.3073 6.03677 6.16349 6.31901C6 6.63988 6 7.05992 6 7.9V13.1C6 13.9401 6 14.3601 6.16349 14.681C6.3073 14.9632 6.53677 15.1927 6.81901 15.3365C7.13988 15.5 7.55992 15.5 8.4 15.5H11.6C12.4401 15.5 12.8601 15.5 13.181 15.3365C13.4632 15.1927 13.6927 14.9632 13.8365 14.681C14 14.3601 14 13.9401 14 13.1V8.5L11 5.5Z",
    stroke: "#213B7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ba86cc10755affae4ea2264388404c27.svg";
export { ForwardRef as ReactComponent };